import React, { useState, useEffect } from 'react';
import { API } from '../lib/api';
import { Icons } from '../components/icons';
import {
  fetchPublicBranding,
  resolveBrandLogoUrl,
  displayCompanyName,
  displayCompanyNameEn,
  displaySystemName,
  DEFAULT_BRAND_LOGO,
  ICP_BEIAN_NO,
  ICP_BEIAN_URL,
} from '@gridorbit/shared';

export function LoginPage({ onLogin }) {
  const [user, setUser] = useState(''); const [pass, setPass] = useState('');
  const [err, setErr] = useState(''); const [loading, setLoading] = useState(false);
  const [logo, setLogo] = useState(DEFAULT_BRAND_LOGO);
  const [companyCn, setCompanyCn] = useState('经纬循道信息');
  const [companyEn, setCompanyEn] = useState('GridOrbit');
  const [systemName, setSystemName] = useState('数据中台');
  const [customLogo, setCustomLogo] = useState(false);

  useEffect(() => {
    fetchPublicBranding().then((b) => {
      setLogo(resolveBrandLogoUrl(b.logo_url));
      setCustomLogo(!!(b.logo_url || '').trim());
      setCompanyCn(displayCompanyName(b));
      setCompanyEn(displayCompanyNameEn(b));
      setSystemName(displaySystemName(b, '数据中台'));
    });
  }, []);

  const submit = async (e) => {
    e.preventDefault(); setErr(''); setLoading(true);
    try {
      const r = await fetch(API+'/api/v1/auth/login', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({username:user, password:pass}) });
      const d = await r.json();
      if (d.code===0) {
        if (d.data.role !== 'platform_admin') { setErr('此账号无法登录平台管理端，请使用超管账号。'); setLoading(false); return; }
        localStorage.setItem('token', d.data.token);
        localStorage.setItem('user', JSON.stringify({id:d.data.user_id, name:d.data.display_name, role:d.data.role}));
        onLogin();
      } else setErr(d.message||'用户名或密码错误');
    } catch(ex) { setErr('网络连接失败'); }
    setLoading(false);
  };
  return (
    <div className="login-page">
      <div className="login-left">
        <div>
          <div className="login-left__logo">
            <img className="login-left__logo-img brand-logo-img" src={logo} alt={companyEn} />
            {customLogo ? (
            <div className="login-left__logo-stack">
              <div className="login-left__logo-cn">{companyCn}</div>
              <div className="login-left__logo-en">{companyEn}</div>
            </div>
            ) : null}
          </div>
          <h1 className="login-left__hero-title">{companyCn} {systemName}</h1>
          <p className="login-left__hero-desc">管理所有租户开户、套餐发放、配额管控与平台模板维护。集中监控多租户运行状态。</p>
          <div className="login-left__features">
            {[
              { icon:<Icons.Users />, title:'租户全生命周期', desc:'开户 → 试用 → 激活 → 暂停 → 注销，完整管控' },
              { icon:<Icons.Plan />, title:'套餐灵活配置', desc:'自定义套餐参数，随时升降配，按需发放' },
              { icon:<Icons.Shield />, title:'平台级审计', desc:'跨租户操作审计，不可篡改日志' },
              { icon:<Icons.Layers />, title:'行业模板库', desc:'平台级 SOP 模板，租户一键复制使用' },
            ].map((f,i)=>(<div className="left-feat" key={i}><div className="left-feat__icon" style={{background:'rgba(var(--brand-primary-rgb),0.1)',color:'var(--brand-primary)'}}>{f.icon}</div><div className="left-feat__title">{f.title}</div><div className="left-feat__desc">{f.desc}</div></div>))}
          </div>
        </div>
      </div>
      <div className="login-right">
        <div className="login-card">
          <div className="login-card__brand">
            <img className="login-card__logo-img brand-logo-img" src={logo} alt={companyEn} />
            {customLogo ? (
            <div>
              <div style={{ fontWeight: 650, fontSize: 14 }}>{companyCn}</div>
              <div style={{ fontSize: 11, color: '#888' }}>{companyEn}</div>
            </div>
            ) : null}
          </div>
          <div className="lc-badge">平台超管入口</div>
          <h2>{systemName}</h2>
          <span className="lc-sub">登录{companyCn}控制台</span>
          {err && <div className="error">{err}</div>}
          <form onSubmit={submit}>
            <div className="form-group"><label>管理员账号</label><input className="form-input" value={user} onChange={e=>setUser(e.target.value)} autoComplete="username" /></div>
            <div className="form-group"><label>密码</label><input className="form-input" type="password" value={pass} onChange={e=>setPass(e.target.value)} autoComplete="current-password" /></div>
            <button className="btn btn-primary" type="submit" disabled={loading} style={{width:'100%',marginTop:4}}>{loading && <span className="spinner" style={{marginRight:8}} />}进入控制台</button>
          </form>
          <div className="login-card__legal">
            <div>© 2026 {companyCn} · {companyEn}</div>
            <a className="login-beian" href={ICP_BEIAN_URL} target="_blank" rel="noopener noreferrer">
              {ICP_BEIAN_NO}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
